import { getBuriedService } from '@rendora/common/services/buried';

export default defineNuxtPlugin(() => {
  if (import.meta.server) {
    // 服务端：注入埋点脚本
    useHead({
      script: [
        {
          async: true,
          innerHTML: `
(function(w, d, s, q) {w[q] =w[q] || []; var f=d.getElementsByTagName(s)[0],j=d.createElement(s); j.async=true; j.id='beacon-aplus'; j.src='https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.umd.js'; f.parentNode.insertBefore(j, f);})(window, document, 'script', 'aplus_queue');
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['appKey', 'yp9o0yljena9pdpgzqums8t1']  });
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['trackDomain', 'https://quickaplus-he-api-cn-shanghai.aliyuncs.com']  });
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['aplus-heatmap-enabled', true] });
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['aplus-autotrack-enabled', false] });
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['DEBUG', true] });
          `,
        },
      ],
    });
    return;
  }

  // 客户端：使用 common 的 BuriedService
  // 注意：BuriedService 已在 00.services.ts 中初始化
  const buriedService = getBuriedService();

  // 提供埋点服务实例给应用使用（保持向后兼容）
  return {
    provide: {
      // 保持向后兼容的接口名称
      buriedTracker: buriedService,
      // 也可以直接提供 service
      buriedService,
    },
  };
});
